<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>
<div class="header-container">
	<p class="mt-2">Create Lead</p>
	<div class="button-container">
		<!-- <button mat-raised-button routerLink="/suzuki/lead-upload"><img class="upload-img"
				src="/assets/images/upload.png" alt=""> Upload</button> -->
	</div>
</div>
<div class="create-lead">
	<mat-stepper [linear]="isLinear" #stepper>
		<mat-step [stepControl]="firstFormGroup">
			<form [formGroup]="firstFormGroup">
				<ng-template matStepLabel>
					<mat-icon class="fa fa-phone"></mat-icon>
					Contact
				</ng-template>
				<div class="formInput mb-1">
					<label>Buyer Type <span class="alert-small">*</span></label>
					<select formControlName="customer_interest"
						[attr.value]="firstFormGroup.get('customer_interest')?.value">
						<option disabled selected value="">Select Buyer Type</option>
						<option *ngFor="let data of customerInterest" id="{{data.id}}"
							[value]="data.id + ':' + data.interest">{{ data.interest }}</option>
					</select>
					<div *ngIf="firstFormSubmitted && f['customer_interest'].errors" class="nvalid-feedback">
						<div *ngIf="f['customer_interest'].errors['required']" class="error-msg">
							Please Select Buyer Type.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>Customer Title <span class="alert-small">*</span></label>
					<select formControlName="title" [attr.value]="firstFormGroup.get('title')?.value">
						<option disabled selected value="">Select Customer Title</option>
						<option *ngFor="let title of customerTitle" [value]="title.id + ':' + title.title">{{
							title.title }}</option>
					</select>
					<div *ngIf="firstFormSubmitted && f['title'].errors" class="nvalid-feedback">
						<div *ngIf="f['title'].errors['required']" class="error-msg">
							Please Select Customer Title.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>First Name <span class="alert-small">*</span></label>
					<input (input)="capitalizeInput($event)" (keydown)="Space($event)" maxlength="40"
						[attr.value]="firstFormGroup.get('first_name')?.value"
						onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" placeholder="Enter First Name"
						formControlName="first_name"
						[ngClass]="{ 'is-invalid': firstFormSubmitted && f['first_name'].errors }">
					<div *ngIf="firstFormSubmitted && f['first_name'].errors" class="invalid-feedback">
						<div *ngIf="f['first_name'].errors['required']" class="error-msg">
							First Name is required.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>Middle Name</label>
					<input (input)="capitalizeInput($event)" (keydown)="Space($event)" maxlength="40"
						[attr.value]="firstFormGroup.get('middle_name')?.value"
						onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" placeholder="Enter Middle Name"
						formControlName="middle_name">
				</div>
				<div class="formInput mb-1">
					<label>Last Name</label>
					<input (input)="capitalizeInput($event)" (keydown)="Space($event)" maxlength="40"
						[attr.value]="firstFormGroup.get('last_name')?.value"
						onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" placeholder="Enter Last Name"
						formControlName="last_name">
				</div>
				<div class="formInput mb-1">
					<label>Email ID</label>
					<input placeholder="Enter Email" formControlName="email"
						[attr.value]="firstFormGroup.get('email')?.value">
					<!-- <input placeholder="Enter Email" formControlName="email" required
						[attr.value]="firstFormGroup.get('email')?.value">
					<div
						*ngIf="firstFormGroup.get('email')?.errors && (firstFormGroup.get('email')?.dirty || firstFormGroup.get('email')?.touched || firstFormSubmitted)">
						<div *ngIf="firstFormGroup.get('email')?.hasError('required')" class="error-msg">
							Email is required.
						</div>
						<div *ngIf="firstFormGroup.get('email')?.hasError('email')" class="error-msg">
							Please enter a valid email address.
						</div>
					</div> -->
				</div>
				<div class="formInput mb-1">
					<label>Gender <span class="alert-small">*</span></label>
					<select formControlName="gender" [attr.value]="firstFormGroup.get('gender')?.value"
						[ngClass]="{ 'is-invalid': firstFormSubmitted && f['gender'].errors }">
						<option value="" disabled>Select Gender</option>
						<option *ngFor="let data of genderList" [value]="data.gender">{{data.gender}}</option>
					</select>
					<div *ngIf="firstFormSubmitted && f['gender'].errors" class="invalid-feedback">
						<div *ngIf="f['gender'].errors['required']" class="error-msg">
							Please Select Gender.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Lead Source <span class="alert-small">*</span></label>
					<select formControlName="source" (change)="onSourceChange($event)"
						[ngClass]="{ 'is-invalid': firstFormSubmitted && f['source'].errors }">
						<option disabled selected value="">Select a Source</option>
						<option *ngFor="let source of sources" [value]="source.id + ':' + source.lead_source">
							{{ source.lead_source }}
						</option>
					</select>
					<div *ngIf="firstFormSubmitted && f['source'].errors" class="invalid-feedback">
						<div *ngIf="f['source'].errors['required']" class="error-msg">
							Please Select Source.
						</div>
					</div>
				</div>
				
				<div class="formInput mb-2" *ngIf="filteredSubSource.length > 0">
					<label>Sub Source <span class="alert-small">*</span></label>
					<select formControlName="sub_source"
						[ngClass]="{ 'is-invalid': firstFormSubmitted && f['sub_source'].errors }">
						<option disabled selected value="">Select a Sub Source</option>
						<option *ngFor="let subSource of filteredSubSource"
							[value]="subSource.id + ':' + subSource.lead_sub_source">
							{{ subSource.lead_sub_source }}
						</option>
					</select>
					<div *ngIf="firstFormSubmitted && f['sub_source'].errors" class="invalid-feedback">
						<div *ngIf="f['sub_source'].errors['required']" class="error-msg">
							Please select a Subsource.
						</div>
					</div>
				</div>
				<div class="formInput mb-2" *ngIf="isShowServiceAdvisor">
					<label>
						Service Advisor <span class="alert-small">*</span>
					</label>
				
					<select formControlName="service_advisor" [ngClass]="{
				      'is-invalid': firstFormSubmitted &&
				                    f['service_advisor'].errors
				    }">
				
						<option value="" disabled>Select a Service Advisor</option>
				
						<option *ngFor="let advisor of filteredServiceAdvisors; trackBy: trackByEmpCode"
							[value]="advisor.emp_code + ':' + advisor.emp_name">
							{{ advisor.emp_name }}
						</option>
				
					</select>
				
					<div *ngIf="firstFormSubmitted && f['service_advisor'].errors" class="invalid-feedback">
				
						<div *ngIf="f['service_advisor'].errors['required']" class="error-msg">
							Please select a Service Advisor.
						</div>
				
					</div>
				</div>
				
				<div class="formInput mb-2" >
					<label style="text-align: start;">Mobile Number <span class="alert-small">*</span></label>
					<input placeholder="Enter Mobile Number" formControlName="mobile" class="mb-2" required
						onpaste="return false;" (keypress)="allowNumbersOnly($event)" maxlength="10"
						pattern="^[6-9][0-9]{9}$">
					<div style="color: red;font-size: 12px;"
						*ngIf="firstFormGroup.get('mobile')?.errors && (firstFormGroup.get('mobile')?.dirty || firstFormGroup.get('mobile')?.touched || firstFormSubmitted)">
						<div *ngIf="firstFormGroup.get('mobile')?.hasError('required')" >
							Mobile Number is required.
						</div>
						<div *ngIf="firstFormGroup.get('mobile')?.hasError('pattern')" >
							Please enter a valid mobile number.
						</div>
					</div>
					<ng-container >
					<div  *ngIf="isShowOtp"  style="text-align: end;">
					<button  class="get-button otp-button" (click)="sendOtp()" *ngIf="!isOtpSent">Get OTP</button>
					<div *ngIf="isOtpSent">
						<div *ngIf="!otpExp">
							<input type="text" placeholder="Enter OTP" (keypress)="allowNumbersOnly($event)"
								onpaste="return false;" formControlName="otp" class="mb-2" maxlength="6">
							<div class="otpmsg" *ngIf="otpSentMessage"> {{ otpSentMessage }}
								<span *ngIf="countdownTime > 0"> (Expires in: {{ getFormattedTime(countdownTime)
									}})</span>
							</div>
						</div>
						<button class="verify-btn otp-button" (click)="otpExp ? sendOtp() : verifyOtp()">
							{{ otpExp ? 'Resend OTP' : 'Submit OTP' }}
						</button>
					</div>
				</div>	
				</ng-container>
				</div>
				<div class="next-btn mt-3">
					<button mat-button matStepperNext *ngIf="isShowOtp" [disabled]="!otpVerified"
						(click)="submitFirstForm()">
						<i class="fa fa-chevron-right ml-2" aria-hidden="true"></i>
						Next
					</button>
					<button mat-button matStepperNext *ngIf="!isShowOtp" 
						(click)="submitFirstForm()">
						<i class="fa fa-chevron-right ml-2" aria-hidden="true"></i>
						Next
					</button>
				</div>

			</form>
		</mat-step>
		<mat-step [stepControl]="secondFormGroup">
			<form [formGroup]="secondFormGroup">
				<ng-template matStepLabel>
					<mat-icon class="fa fa-address-card"></mat-icon>
					Lead Details
				</ng-template>
				
				<div class="formInput mb-1" *ngIf="isShowReference">
					<label>Reference Type <span class="alert-small">*</span></label>
					<select formControlName="reference_type"
						[attr.value]="secondFormGroup.get('reference_type')?.value">
						<option disabled selected value="">Select Reference Type</option>
						<option *ngFor="let data of referenceType" id="{{data.id}}" [value]="data.id + ':' + data.type">
							{{ data.type }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['reference_type'].errors" class="nvalid-feedback">
						<div *ngIf="f['reference_type'].errors['required']" class="error-msg">
							Please Select Reference Type.
						</div>
					</div>
				</div>
				<div class="formInput mb-1" *ngIf="isShowReference">
					<label>Reference By <span class="alert-small">*</span></label>
					<input type="text" formControlName="reference_by"
						[attr.value]="secondFormGroup.get('reference_by')?.value">
					<div *ngIf="secondFormSubmitted && f['reference_by'].errors" class="nvalid-feedback">
						<div *ngIf="f['reference_by'].errors['required']" class="error-msg">
							Reference by is required.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Product Category <span class="alert-small">*</span></label>
					<select formControlName="product_category"
						[attr.value]="secondFormGroup.get('product_category')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['product_category'].errors }"
						(change)="onCategoryChange($event)">
						<option disabled selected value="">Select a Product Category</option>
						<ng-container *ngFor="let category of categories">
							<option [value]="category.id  + ':' + category.product_categories">{{
								category.product_categories }}</option>
						</ng-container>
					</select>
					<div *ngIf="secondFormSubmitted && f['product_category'].errors" class="invalid-feedback">
						<div *ngIf="f['product_category'].errors['required']" class="error-msg">
							Please Select Product Category.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Product Model <span class="alert-small">*</span></label>
					<select formControlName="product_model" [attr.value]="secondFormGroup.get('product_model')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['product_model'].errors }"
						(change)="onModelChange($event)">
						<option disabled selected value="">Select a Product Model</option>
						<option *ngFor="let product of filteredProducts" id="{{product.id}}"
							[value]="product.id + ':' + product.model">{{ product.model }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['product_model'].errors" class="invalid-feedback">
						<div *ngIf="f['product_model'].errors['required']" class="error-msg">
							Please Select Product Model.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Product Variant <span class="alert-small">*</span></label>
					<select formControlName="product_variant"
						[attr.value]="secondFormGroup.get('product_variant')?.value" (change)="onVariantChange($event)"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['product_variant'].errors }">
						<option value="" selected disabled>Select Product Variant</option>
						<option *ngFor="let variant of filteredVariants" [value]="variant.id +':'+ variant.variant">{{
							variant.variant }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['product_variant'].errors" class="invalid-feedback">
						<div *ngIf="f['product_variant'].errors['required']" class="error-msg">
							Please Select Product Variant.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Product Color <span class="alert-small">*</span></label>
					<select formControlName="product_color" [attr.value]="secondFormGroup.get('product_color')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['product_color'].errors }">
						<option value="" selected disabled>Select Product Color</option>
						<option *ngFor="let color of filteredColors" [value]="color.id +':'+ color.color">{{ color.color
							}}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['product_color'].errors" class="invalid-feedback">
						<div *ngIf="f['product_color'].errors['required']" class="error-msg">
							Please Select Product Color.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Finance Source <span class="alert-small">*</span></label>
					<select formControlName="finance" [attr.value]="secondFormGroup.get('finance')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['finance'].errors }">
						<option disabled selected value="">Select Finance Source</option>
						<option *ngFor="let data of financeSource" id="{{data.id}}"
							[value]="data.id + ':' + data.finance">{{ data.finance }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['finance'].errors" class="invalid-feedback">
						<div *ngIf="f['finance'].errors['required']" class="error-msg">
							Please Select Finance Source.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Profession <span class="alert-small">*</span></label>
					<select formControlName="profession" [attr.value]="secondFormGroup.get('profession')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['profession'].errors }">
						<option disabled selected value="">Select Profession</option>
						<option *ngFor="let data of professionList" id="{{data.id}}"
							[value]="data.id + ':' + data.occupation">{{ data.occupation }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['profession'].errors" class="invalid-feedback">
						<div *ngIf="f['profession'].errors['required']" class="error-msg">
							Please Select Profession.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Customer Type <span class="alert-small">*</span></label>
					<select formControlName="customer_type" [attr.value]="secondFormGroup.get('customerType')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['customer_type'].errors }"
						(change)="onCustomerTypeChange($event)">
						<option disabled selected value="">Select Customer Type</option>
						<option *ngFor="let data of customerType" id="{{data.id}}"
							[value]="data.id + ':' + data.customer_type">{{ data.customer_type }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['customer_type'].errors" class="invalid-feedback">
						<div *ngIf="f['customer_type'].errors['required']" class="error-msg">
							Please Select Customer Type.
						</div>
					</div>
				</div>
				<!-- <div class="formInput mb-1" *ngIf="isShowCompanyName">
					<label>Company Name <span class="alert-small">*</span></label>
					<input (input)="capitalizeInput($event)" (keydown)="Space($event)" maxlength="150"
						[attr.value]="secondFormGroup.get('company_name')?.value"
						onkeydown="return /^[a-zA-Z\s]*$/i.test(event.key)" placeholder="Enter Company"
						formControlName="company_name"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['company_name'].errors }">
					<div *ngIf="secondFormSubmitted && f['company_name'].errors" class="invalid-feedback">
						<div *ngIf="f['company_name'].errors['required']" class="error-msg">
							Company Name is required.
						</div>
					</div>
				</div> -->
				<div class="formInput mb-1" *ngIf="isShowCompanyName">
					<label>Company Name </label>
					<select formControlName="corporate" [attr.value]="secondFormGroup.get('corporate')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['corporate'].errors }"
						>
						<option disabled selected value="">Select Corporate</option>
						<option *ngFor="let data of corporateList" id="{{data.id}}"
							[value]="data.id + ':' + data.corporate_name">{{ data.corporate_name }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['corporate'].errors" class="invalid-feedback">
						<div *ngIf="f['corporate'].errors['required']" class="error-msg">
							Company Name is required.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>Age Group <span class="alert-small">*</span></label>
					<select formControlName="age_group" [attr.value]="secondFormGroup.get('age_group')?.value"
						[ngClass]="{ 'is-invalid': secondFormSubmitted && f['age_group'].errors }">
						<option value="" disabled>Select Age Group</option>
						<option *ngFor="let data of ageGroupList" [value]="data.id + ':' + data.age_group">
							{{data.age_group}}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['age_group'].errors" class="invalid-feedback">
						<div *ngIf="f['age_group'].errors['required']" class="error-msg">
							Please Select Age Group.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>Days to Purchase <span class="alert-small">*</span></label>
					<select formControlName="days_to_purchase"
						[attr.value]="secondFormGroup.get('days_to_purchase')?.value">
						<option disabled selected value="">Select</option>
						<option *ngFor="let data of daysToPruchaseList" id="{{data.id}}" [value]="data.id">{{ data.value
							}}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['days_to_purchase'].errors" class="nvalid-feedback">
						<div *ngIf="f['days_to_purchase'].errors['required']" class="error-msg">
							Please Select Days to Purchase.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>Do you wish to exchange your old vehicle? <span class="alert-small">*</span></label>
					<select formControlName="exchange" [attr.value]="secondFormGroup.get('exchange')?.value">
						<option disabled selected value="">Select </option>
						<option value="YES">Yes</option>
						<option value="NO">No</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['exchange'].errors" class="nvalid-feedback">
						<div *ngIf="f['exchange'].errors['required']" class="error-msg">
							Please Select.
						</div>
					</div>
				</div>
				<div class="formInput mb-1">
					<label>Do you wish to get a Quotation? <span class="alert-small">*</span></label>
					<select formControlName="quotation" [attr.value]="secondFormGroup.get('quotation')?.value">
						<option disabled selected value="">Select</option>
						<option value="YES">Yes</option>
						<option value="NO">No</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['quotation'].errors" class="nvalid-feedback">
						<div *ngIf="f['quotation'].errors['required']" class="error-msg">
							Please Select.
						</div>
					</div>
				</div>
				<div class="formInput">
					<label>DSE <span class="alert-small">*</span></label>
					<select formControlName="sales_manager" (change)="onSalesManagerSelected()"
						[attr.value]="secondFormGroup.get('sales_manager')?.value">
						<option disabled selected value="">Select DSE</option>
						<option *ngFor="let salesmanager of filteredSalesManagers" [value]="salesmanager.user_id">{{
							salesmanager.first_name }}</option>
					</select>
					<div *ngIf="secondFormSubmitted && f['sales_manager'].errors" class="nvalid-feedback">
						<div *ngIf="f['sales_manager'].errors['required']" class="error-msg">
							Please Select DSE.
						</div>
					</div>
				</div>


				<div class="formInput">
					<label>Remarks</label>
					<textarea type="textarea" placeholder="Enter Remarks" formControlName="remarks" rows="3"
						[attr.value]="secondFormGroup.get('remarks')?.value"></textarea>
					<div
						*ngIf="secondFormGroup.get('remarks')?.errors && (secondFormGroup.get('remarks')?.dirty || secondFormGroup.get('remarks')?.touched || secondFormSubmitted)">
						<div *ngIf="secondFormGroup.get('remarks')?.hasError('required')" class="error-msg">
							Please Enter Remarks.
						</div>
					</div>
				</div>
				<div class="submit-btn">
					<button mat-button matStepperPrevious (click)="previous()">
						<i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>Back</button>
					<button mat-button matStepperNext (click)="submitSecondForm()">
						<i class="fa fa-chevron-right ml-2" aria-hidden="true"></i>
						Next
					</button>
				</div>
			</form>
		</mat-step>
		<mat-step [stepControl]="thirdFormGroup">
			<form [formGroup]="thirdFormGroup">
				<ng-template matStepLabel>
					<mat-icon class="fa fa-calendar"></mat-icon>
					Follow-up
				</ng-template>
				<div class="formInput">
					<label for="followupdate" class="form-label">
						Follow-up Date <span class="alert-small">*</span>
					</label>
					<div class="input-group">
						<input readonly class="form-control" style="cursor: pointer;" #inputField
							(click)="picker.open()" [attr.value]="thirdFormGroup.get('date')?.value"
							[matDatepicker]="picker" formControlName="date" placeholder="Select Date" [min]="minDate">
						
						<!-- <input readonly class="form-control" style="cursor: pointer;" #inputField
							[attr.value]="thirdFormGroup.get('date')?.value"
							formControlName="date"> -->
						<div class="input-group-append">
							<span class="input-group-text" (click)="picker.open()" style="cursor: pointer;">
								<i class="fa fa-calendar" aria-hidden="true"></i>
							</span>
						</div>
					</div>
					<mat-datepicker #picker></mat-datepicker>
					<div *ngIf="thirdFormSubmitted && f['date'].errors">
						<div *ngIf="thirdFormGroup.get('date')?.errors?.['required']" class="error-msg">
							Please Select Follow-up Date.
						</div>
					</div>
				</div>

				<div class="formInput">
					<label for="followuptime" class="form-label">
						Follow-up Time <span class="alert-small">*</span>
					</label>
					<div class="input-group">
						<input type="text" readonly class="form-control"
							[attr.value]="thirdFormGroup.get('time')?.value" formControlName="time" matInput
							[matTimepicker]="timepicker" (click)="timepicker.open()" placeholder="Select Time" />
						<div class="input-group-append">
							<span class="input-group-text" (click)="timepicker.open()" style="cursor: pointer;">
								<i class="fa fa-clock" aria-hidden="true"></i>
							</span>
						</div>
					</div>
					<mat-timepicker #timepicker touchUi mode="input"></mat-timepicker>

					<div style="margin-top: -20px" *ngIf="thirdFormSubmitted  && f['time'].errors">
						<div *ngIf="thirdFormGroup.get('time')?.errors?.['required']" class="error-msg">
							Please Select Follow-up Time.
						</div>
					</div>
				</div>

				<!-- <div class="formInput">
					<label for="followuptime" class="form-label">
						Follow-up Time <span class="alert-small">*</span>
					</label>
					<div class="input-group">
						<input type="text" 
								readonly 
								class="form-control"
								formControlName="time" matInput
								[matTimepicker]="timepicker" 
								(click)="timepicker.open()" 
								placeholder="Select Time" />
						<div class="input-group-append">
							<span class="input-group-text" (click)="timepicker.open()" style="cursor: pointer;">
								<i class="fa fa-clock" aria-hidden="true"></i>
							</span>
						</div>
					</div>
					<mat-timepicker #timepicker touchUi mode="input"></mat-timepicker>
					<div *ngIf="thirdFormGroup.get('time')?.errors?.['futureTime']"
							class="error-msg">
						Selected time cannot be greater than current time.
					</div>
					
				</div> -->

				<div class="formInput mt-3">
					<label>Action <span class="alert-small">*</span></label>
					<select formControlName="action" (change)="onSalesManagerSelected()"
						[attr.value]="secondFormGroup.get('action')?.value">
						<option disabled selected value="">Select Action</option>
						<option *ngFor="let data of actionList" [value]="data.id + ':' + data.mode_of_contact">{{
							data.mode_of_contact }}</option>
					</select>
					<div *ngIf="thirdFormSubmitted && f['action'].errors" >
						<div *ngIf="f['action'].errors['required']" class="error-msg">
							Please Select Action.
						</div>
					</div>
				</div>

				<div class="formInput">
					<label>Follow-up <span class="alert-small">*</span></label>
					<select formControlName="followup" (change)="onSalesManagerSelected()"
						[attr.value]="secondFormGroup.get('followup')?.value">
						<option disabled selected value="">Select Follow-up</option>
						<option *ngFor="let data of followupList" [value]="data.id + ':' + data.reason">{{
							data.reason }}</option>
					</select>
					<div *ngIf="thirdFormSubmitted && f['followup'].errors">
						<div *ngIf="f['followup'].errors['required']" class="error-msg">
							Please Select Follow-up.
						</div>
					</div>
				</div>
				<div class="submit-btn">
					<button mat-button matStepperPrevious (click)="previous()">
						<i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>Back</button>
					<button class="ml-2" mat-button (click)="submitThirdForm()"
						style="background-color: #1890FF;color: #fff;">Submit</button>
				</div>
			</form>
		</mat-step>
	</mat-stepper>
</div>